VP = window.VP || {};

/*
 * This will target all subhead elements
 * and add a class 'vp-subhead' as parent class
*/

(function( $ ) {
	VP.subhead = {
		init: function () {
			$('.vp-body-subhead').parent().addClass('vp-subhead');
			$('.vp-body-subhead-2').parent().addClass('vp-subhead');


		}
	};
})(jQuery);
